import {
	isStoreAssistant,
	type StoreChatItem,
	type StoreHuman,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { findPreviousByTypeFromId } from './findPreviousByTypeFromId';
import { getAgentMessageById } from './getAgentMessageById';

export const getAssociatedHumanMessageId = (
	messages: StoreChatItem[],
	agentMessageId: string,
): string | undefined => {
	try {
		const agentMessage = getAgentMessageById(messages, agentMessageId).result;
		if (agentMessage && isStoreAssistant(agentMessage)) {
			const foundId = findPreviousByTypeFromId<StoreHuman>({
				messages,
				messageId: agentMessageId,
				searchType: 'HUMAN',
			})?.content.id;
			return foundId ? String(foundId) : undefined;
		}
	} catch {
		return undefined;
	}
};
